<template>
  <div class="griddy-contain">
    <div class="griddy container is-flui">
      <div class="columns">
        <div class="column"></div>
        <div class="column is-hidden-mobile">
          <h1>SARIKAYA
            <span class="plus">+</span> <span class="s">S</span>AH<span class="i">I</span>N</h1>
        </div>
      </div>
      <div class="columns">
        <div class="column"></div>
        <div class="column">
          <p>Today, the impact of rapid changes in technology and economy is also manifested in the field of law. Therefore, these changes bring the necessity for dynamic, open-minded and professionally up-to-date lawyers more than ever. Sarıkaya + Şahin aims to respond to these necessities while enhancing its services to come along with the best possible solutions.</p>
          <span class="liner"></span>
        </div>
      </div>

    </div>
    <videoBg></videoBg>
  </div>
</template>

<script>
import videoBg from "@/components/videoBg.vue";

export default {
  components: {
    videoBg
  },
  name: 'hello',
  data() {
    return {

    }
  },
  // mounted() {
  //     if (this.$root._route.meta.policy) {
  //       this.policy = true
  //       console.log('DENEMEDİR')
  //   } else {
  //       this.policy = false
  //   }
  // },
  computed: {

  },
}
</script>

<style scoped>
.griddy,
.griddy-contain {
  height: 90%;
  display: flex;
  flex-direction: column;
}

.griddy .columns {
  flex: 1;
}

.column.is-8 p {
  margin-right: 200px;
  color: whitesmoke;
}

.griddy .column {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.columns:nth-child(1) {
  flex: 2;
}

.columns:nth-child(1) .column:nth-child(2) {
  font-size: 59px;
  font-weight: 900;
  font-family: 'SEC', sans-serif;
  color: #e4e4e4;
  align-items: flex-end;
}

.liner {
  position: absolute;
  height: 1px;
  bottom: 0;
  width: 199%;
  background: #81A716;
  ;
}

.plus {
  color: #81A716;
  vertical-align: baseline;
  font-family: 'Comic-Sans', sans-serif;
}

.plus::hover {
  transition: all 0.3s ease-in-out;
  transform: rotate(180deg);
}

.columns:nth-child(2) .column:nth-child(2) {
  align-items: flex-start;
}

.hello {
  height: 100%;
}

.navk {
  justify-content: center;
}

.navk a:hover {
  border-bottom-color: #00d1b2;
  border-bottom-style: solid;
  border-bottom-width: 3px;
  color: #2c8c7e;
  padding-bottom: calc(0.5rem - 3px);
}

.hello h1 {
  padding-bottom: 250px;
}

.s {
  position: relative;
}

.s::after {
  content: "";
  height: 4px;
  width: 2px;
  background: black;
  position: absolute;
  bottom: 7px;
  left: 0;
  right: 0;
  margin: auto;
}

.i {
  position: relative;
}

.i::after {
  content: "";
  height: 4px;
  width: 1px;
  background: black;
  position: absolute;
  top: 7px;
  left: 0;
  right: 0;
  margin: auto;
}

html {
  font-size: 14px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #a2a2a2;
}

p {
  color: #e6e6e6;
  text-align: justify;
  font-size: 1.3rem;
  text-shadow: 2px 2px 4px black;
}

@media only screen and (max-width: 768px) {
  .griddy-contain {
    height: 68%;
  }
  .griddy {
    justify-content: center;
    align-items: center;
  }
  .columns:nth-child(1) {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .columns {
    width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// homepage.vue?87412396